import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

const INSPECT_TYPES = {
  security: '秩序巡逻',
  engineer: '工程巡检',
  steward: '管家巡检',
  admin: '工程巡检',
  manager: '管家巡检'
};

const FIXED_LOCATIONS = ['楼幢','地面','楼顶','地下室','小区外围','自定义'];
const BUILDINGS = ['1幢','2幢','3幢','5幢','6幢'];

const FEEDBACK_ITEMS = [
  { key: 'drain', label: '排水是否正常' },
  { key: 'basement_water', label: '地下车库有无积水' },
  { key: 'safety', label: '有无安全隐患' },
  { key: 'hygiene', label: '卫生状况' },
  { key: 'items', label: '物品是否整齐' },
  { key: 'lights', label: '灯光是否正常' },
  { key: 'parking', label: '车辆停放是否正常' },
];

export default function AddInspection({ user }) {
  const navigate = useNavigate();
  const inspectType = INSPECT_TYPES[user.role] || '工程巡检';

  const now = new Date();
  const localNow = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0,16);

  const [form, setForm] = useState({
    type: inspectType,
    inspect_time: localNow,
    location_type: '地面',
    building: '',
    custom_location: '',
  });
  const [feedback, setFeedback] = useState(
    Object.fromEntries(FEEDBACK_ITEMS.map(i => [i.key+'_ok', 1]))
  );
  const [notes, setNotes] = useState({});
  const [customItems, setCustomItems] = useState([]);
  const [customLocations, setCustomLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get('/inspections/locations').then(r => setCustomLocations(r.data)).catch(() => {});
  }, []);

  const setFb = (key, val) => setFeedback(f => ({ ...f, [key+'_ok']: val }));
  const setNote = (key, val) => setNotes(n => ({ ...n, [key+'_note']: val }));

  const addCustomItem = () => setCustomItems(prev => [...prev, { item_name: '', is_ok: 1, note: '' }]);
  const updateCustomItem = (idx, field, val) => {
    setCustomItems(prev => prev.map((item, i) => i === idx ? { ...item, [field]: val } : item));
  };
  const removeCustomItem = (idx) => setCustomItems(prev => prev.filter((_, i) => i !== idx));

  const handleSubmit = async () => {
    if (form.location_type === '楼幢' && !form.building) { alert('请选择楼幢'); return; }
    if (form.location_type === '自定义' && !form.custom_location) { alert('请填写自定义地点'); return; }
    setLoading(true);
    try {
      const payload = {
        ...form,
        ...Object.fromEntries(FEEDBACK_ITEMS.map(i => [i.key+'_ok', feedback[i.key+'_ok']])),
        ...Object.fromEntries(FEEDBACK_ITEMS.map(i => [i.key+'_note', notes[i.key+'_note'] || ''])),
        custom_items: customItems.filter(i => i.item_name.trim())
      };
      await API.post('/inspections', payload);
      alert('巡检记录提交成功');
      navigate('/inspect');
    } catch (err) {
      alert(err.response?.data?.message || '提交失败');
    } finally {
      setLoading(false);
    }
  };

  const FeedbackItem = ({ item }) => (
    <div style={styles.fbItem}>
      <div style={styles.fbTop}>
        <span style={styles.fbLabel}>{item.label}</span>
        <div style={styles.fbBtns}>
          <button style={{...styles.fbBtn, ...(feedback[item.key+'_ok']===1 ? styles.fbBtnOk : {})}}
            onClick={() => setFb(item.key, 1)}>正常</button>
          <button style={{...styles.fbBtn, ...(feedback[item.key+'_ok']===0 ? styles.fbBtnBad : {})}}
            onClick={() => setFb(item.key, 0)}>异常</button>
        </div>
      </div>
      {feedback[item.key+'_ok'] === 0 && (
        <input style={styles.noteInput} placeholder="请说明异常情况..."
          value={notes[item.key+'_note'] || ''}
          onChange={e => setNote(item.key, e.target.value)} />
      )}
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.back} onClick={() => navigate(-1)}>← 返回</button>
        <h2 style={styles.headerTitle}>{inspectType}</h2>
        <div style={{width:60}} />
      </div>

      <div style={styles.form}>
        {/* 巡检时间 */}
        <div style={styles.field}>
          <label style={styles.label}>巡检时间</label>
          <input type="datetime-local" style={styles.input}
            value={form.inspect_time}
            onChange={e => setForm({...form, inspect_time: e.target.value})} />
        </div>

        {/* 地点类型 */}
        <div style={styles.field}>
          <label style={styles.label}>巡检地点</label>
          <div style={styles.radioGroup}>
            {FIXED_LOCATIONS.map(loc => (
              <button key={loc}
                style={{...styles.radioBtn, ...(form.location_type===loc ? styles.radioBtnActive : {})}}
                onClick={() => setForm({...form, location_type: loc, building:'', custom_location:''})}>
                {loc}
              </button>
            ))}
          </div>
          {form.location_type === '楼幢' && (
            <div style={{...styles.radioGroup, marginTop:'8px'}}>
              {BUILDINGS.map(b => (
                <button key={b}
                  style={{...styles.radioBtn, ...(form.building===b ? styles.radioBtnActive : {})}}
                  onClick={() => setForm({...form, building: b})}>
                  {b}
                </button>
              ))}
            </div>
          )}
          {form.location_type === '自定义' && (
            <div style={{marginTop:'8px'}}>
              {customLocations.length > 0 && (
                <div style={{...styles.radioGroup, marginBottom:'8px'}}>
                  {customLocations.map(cl => (
                    <button key={cl.id}
                      style={{...styles.radioBtn, ...(form.custom_location===cl.name ? styles.radioBtnActive : {})}}
                      onClick={() => setForm({...form, custom_location: cl.name})}>
                      {cl.name}
                    </button>
                  ))}
                </div>
              )}
              <input style={styles.input} placeholder="输入新地点名称（自动保存）"
                value={form.custom_location}
                onChange={e => setForm({...form, custom_location: e.target.value})} />
            </div>
          )}
        </div>

        {/* 反馈项目 */}
        <div style={styles.field}>
          <label style={styles.label}>巡检反馈</label>
          <div style={styles.fbCard}>
            {FEEDBACK_ITEMS.map(item => <FeedbackItem key={item.key} item={item} />)}

            {/* 自定义项 */}
            {customItems.map((item, idx) => (
              <div key={idx} style={styles.fbItem}>
                <div style={styles.fbTop}>
                  <input style={{...styles.noteInput, flex:1, marginBottom:0}}
                    placeholder="自定义项目名称"
                    value={item.item_name}
                    onChange={e => updateCustomItem(idx, 'item_name', e.target.value)} />
                  <div style={styles.fbBtns}>
                    <button style={{...styles.fbBtn, ...(item.is_ok===1 ? styles.fbBtnOk : {})}}
                      onClick={() => updateCustomItem(idx, 'is_ok', 1)}>正常</button>
                    <button style={{...styles.fbBtn, ...(item.is_ok===0 ? styles.fbBtnBad : {})}}
                      onClick={() => updateCustomItem(idx, 'is_ok', 0)}>异常</button>
                    <button style={styles.fbDelBtn} onClick={() => removeCustomItem(idx)}>×</button>
                  </div>
                </div>
                {item.is_ok === 0 && (
                  <input style={styles.noteInput} placeholder="说明异常情况..."
                    value={item.note}
                    onChange={e => updateCustomItem(idx, 'note', e.target.value)} />
                )}
              </div>
            ))}
            <button style={styles.addItemBtn} onClick={addCustomItem}>+ 添加自定义项目</button>
          </div>
        </div>

        <button style={{...styles.submitBtn, opacity: loading ? 0.7 : 1}}
          onClick={handleSubmit} disabled={loading}>
          {loading ? '提交中...' : '提 交'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f5f7fa', paddingBottom: '30px' },
  header: {
    background: 'linear-gradient(90deg, #1a6a3a, #2d9d5a)',
    padding: '16px', display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', position: 'sticky', top: 0, zIndex: 100
  },
  back: { background: 'transparent', border: 'none', color: '#fff', fontSize: '16px', cursor: 'pointer' },
  headerTitle: { color: '#fff', margin: 0, fontSize: '18px', fontWeight: 700 },
  form: { padding: '16px' },
  field: { marginBottom: '16px' },
  label: { display: 'block', fontWeight: 600, color: '#333', marginBottom: '8px', fontSize: '15px' },
  input: { width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '15px', boxSizing: 'border-box' },
  radioGroup: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  radioBtn: { padding: '8px 14px', border: '1.5px solid #e0e0e0', borderRadius: '20px', background: '#fff', fontSize: '14px', cursor: 'pointer' },
  radioBtnActive: { background: '#1a6a3a', color: '#fff', borderColor: '#1a6a3a' },
  fbCard: { background: '#fff', borderRadius: '12px', padding: '4px 12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  fbItem: { padding: '12px 0', borderBottom: '1px solid #f5f5f5' },
  fbTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' },
  fbLabel: { fontSize: '14px', color: '#333', flex: 1 },
  fbBtns: { display: 'flex', gap: '6px' },
  fbBtn: { padding: '5px 12px', border: '1.5px solid #e0e0e0', borderRadius: '14px', background: '#fff', fontSize: '13px', cursor: 'pointer' },
  fbBtnOk: { background: '#52c41a', color: '#fff', borderColor: '#52c41a' },
  fbBtnBad: { background: '#ff4d4f', color: '#fff', borderColor: '#ff4d4f' },
  fbDelBtn: { padding: '5px 8px', border: 'none', background: '#ff4d4f', color: '#fff', borderRadius: '14px', fontSize: '13px', cursor: 'pointer' },
  noteInput: { width: '100%', marginTop: '8px', padding: '8px 10px', border: '1.5px solid #ffccc7', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', background: '#fff5f5' },
  addItemBtn: { width: '100%', padding: '10px', border: '1.5px dashed #1a6a3a', borderRadius: '8px', background: '#f6ffed', color: '#1a6a3a', fontSize: '14px', cursor: 'pointer', marginTop: '8px', marginBottom: '4px' },
  submitBtn: { width: '100%', padding: '14px', background: 'linear-gradient(90deg, #1a6a3a, #2d9d5a)', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '17px', fontWeight: 700, cursor: 'pointer', marginTop: '10px' }
};
